import { useNavigate } from 'react-router-dom';
import classes from './Chip.module.css';

interface IChipProps {
    text: string;
    url?: string;
    title?: string;
    mode?: 'info' | 'attention' | 'highlighted' | 'plain';
}

const Chip: React.FC<IChipProps> = ({ text, url, title, mode = 'info' }) => {
    const navigate = useNavigate();

    if (url) {
        return (
            <span
                className={`${classes.chip} ${classes[mode]}`}
                title={title}
                role="link"
                tabIndex={0}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    navigate(url);
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        e.stopPropagation();
                        navigate(url);
                    }
                }}
                aria-label={title || text}
            >
                {text}
            </span>
        );
    } else {
        return (
            <span className={`${classes.chip} ${classes[mode]}`} title={title}>
                {text}
            </span>
        );
    }
};

export default Chip;
